import styled from "styled-components";

const Wrapper = styled.section`
  & .main_div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default Wrapper;
